// Shared query-key prefix for recognition list queries (drafts + flagged) so that
// mutations can invalidate them together. Kept in a dedicated module so it can be
// imported without pulling in a specific list hook.
export const ALL_RECOGNITION_QK = 'LIST_PAGINATED_RECOGNITIONS_QUERY_KEY'
